import Cookies from 'js-cookie'

import { IS_LOGGED_IN_COOKIE_NAME } from '@/lib/constants'

// Manually call this when user log in
export async function onLogin(apolloClient, token) {
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    // await apolloClient.resetStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (login)', 'color: orange;', e.message)
  }
}

// Manually call this when user log out
export async function onLogout(apolloClient) {
  // Remove both local and domain cookies on logout
  Cookies.remove(IS_LOGGED_IN_COOKIE_NAME)
  Cookies.remove(IS_LOGGED_IN_COOKIE_NAME, {
    domain: process.env.VUE_APP_ROOT_DOMAIN
  })
  if (apolloClient.wsClient) restartWebsockets(apolloClient.wsClient)
  try {
    await apolloClient.clearStore()
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('%cError on cache reset (logout)', 'color: orange;', e.message)
  }
}
